import * as React from 'react';
import { useGetCompaniesAdminQuery } from 'src/redux/services/companiesAdmin';
import { selectUser } from 'src/redux/slices/userSlice';
import { useSelector } from 'react-redux';
import { isAdmin } from 'src/utils/user';

export interface CompanyOption {
  key: string;
  title: string;
}

export const useGetCompaniesOptions = () => {
  const [companiesWithNoDuplicates, setCompaniesWithNoDuplicates] = React.useState<
    {
      id: string;
      name: string;
    }[]
  >([]);
  const [companiesOptions, setCompaniesOptions] = React.useState<CompanyOption[]>([]);

  const user = useSelector(selectUser);
  const isUserAdmin = isAdmin(user);

  const { data: companiesData } = useGetCompaniesAdminQuery(
    {
      start: 0,
      max_items: 2000,
      search: '',
    },
    { skip: !isUserAdmin }
  );

  React.useEffect(() => {
    // Returns the list of companies where for each company with the same name, the id is appended to the name
    if (companiesData) {
      const _companiesWithNoDuplicates = companiesData.items
        .filter((comp) => !comp.deleted_at)
        .map((comp) => {
          if (companiesData.items.find((c) => comp.name === c.name && comp.id !== c.id)) {
            return {
              ...comp,
              name: `${comp.name} (${comp.id.substring(0, 7)})`,
            };
          }
          return comp;
        });
      setCompaniesWithNoDuplicates(_companiesWithNoDuplicates);
    }
  }, [companiesData]);

  React.useEffect(() => {
    const _companiesOptions: CompanyOption[] = companiesWithNoDuplicates
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
      .map((c) => ({
        key: c.id,
        title: c.name,
      }));
    setCompaniesOptions(_companiesOptions);
  }, [companiesWithNoDuplicates]);

  return [companiesOptions, companiesWithNoDuplicates];
};
